import moment from 'moment';

export enum ExpirationOption {
  Days180 = '180days',
  OneYear = '1year',
  Custom = 'custom',
  NoExpiration = 'noExpiration',
  NoChange = 'noChange',
}

/**
 * Calculates the expiration date based on the provided option and custom date.
 *
 * @param option - The expiration option ('180days', '1year', 'custom', 'noExpiration', or 'noChange')
 * @param customDate - The custom date to use when option is 'custom'
 * @returns The calculated expiration date, null for no expiration, or undefined if invalid/noChange
 */
export const calculateExpirationDate = (
  option: ExpirationOption,
  customDate?: Date,
): Date | null | undefined => {
  const now = moment();

  switch (option) {
    case ExpirationOption.Days180:
      return now.clone().add(180, 'days').toDate();
    case ExpirationOption.OneYear:
      return now.clone().add(1, 'year').toDate();
    case ExpirationOption.Custom:
      return customDate;
    case ExpirationOption.NoExpiration:
      return null;
    case ExpirationOption.NoChange:
      return undefined;
    default:
      return undefined;
  }
};
